<template>
  <div class="badain-jaran">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <CarMainBanner :is-mobile="isMobile"
      banner-name="BadainJaran"
      :banner-url="imgUrlPrefix + mainBanner"
      :title="mainTitle"
      sub-title="时尚经典 极致越野"
      mobile-font-color="dark"
      @pageLoad="pageLoad"
    />

    <!-- 两列布局组件 -->
    <CarBannerTwoColumn :is-mobile="isMobile" :two-column-list="carBannerTwoColumnList" />

    <!-- 购车权益 -->
    <div>

      <img

        class="img-cover"

        :src="imgUrlPrefix + (isMobile ? 'rights-banner.jpg' : 'rights-bg.jpg')"

        alt="购车权益"

      />

    </div>

    <!-- 上下布局组件: 上文字+下图片 -->
    <div v-if="isMobile"  class="sec-4-box">
      <div class="sec-4-item">
        <img class="img-cover" :src="imgUrlPrefix + 'm-sec4_1.jpg'" alt="" />
        <div class="sec-4-txt fade-up">
          <p>每个时代皆烙印着独属于自己的非凡传奇<br>212，为中国越野而生<br>承载半个世纪的越野情怀</p>
          <h5>让过往的荣耀<br>自然生长进未来<br>LIVEPASSION<br>&nbsp;&nbsp;DRIVE LEGEND！</h5>
        </div>
      </div>
      <div class="sec-4-item">
        <img class="img-cover" :src="imgUrlPrefix + 'm-sec4_2.jpg'" alt="" />
        <div class="sec-4-txt fade-up">
          <h5>值得拥有<br>前卫的经典主义</h5>
          <p style="margin-top: 1.6vw;"></p>
        </div>
      </div>
    </div>
    <CarUpTxtDownImg v-else :txt-img-obj="carUpTxtDownImgObject" />
    <div v-if="!isMobile" class="sec-4-item-pc fill-section-1080">
        <img class="img-cover" :src="imgUrlPrefix + 'sec1_2.jpg'" alt="" />
        <div class="sec-4-txt-pc fade-up" style="position:absolute;left: 30px;bottom: 80px;">
          <h5 style="color: #fff;font-size: clamp(38px, 2.5vw, 48px);font-weight: 100;">值得拥有前卫的经典主义</h5>
          <p style="margin-top: 0vw;color: #fff;font-size: clamp(16px, 1.25vw, 24px)px;font-weight: 200;">让越野更有范</p>
        </div>
      </div>

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList" />


    <!-- 轮播组件 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj" />
    <CarBannerCarousel v-else :carousel-list="carBannerCarouselList" />

    <!-- 图文混排组件 2 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList2" mobile-font-color="light" />

    <!-- 幻灯片组件 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj2" />
    <CarSlideComponent v-else title="驾乘友好" :slide-list="carSlideList" />

    <!-- 图文混排组件 3 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList3" />

    <!-- 幻灯片组件 2 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj3" />
    <CarSlideComponent v-else title="智慧体验 科技友好" :slide-list="carSlideList2" />

    <!-- 图文混排组件 4 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList4" mobile-font-color="light" />

    <!-- 幻灯片组件 3 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj4" />
    <CarSlideComponent v-else title="黄金动力 核心强韧" :slide-list="carSlideList3" />

    <!-- 幻灯片组件 4 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj5" />
    <CarSlideComponent v-else title="硬核选择 全域通行" :slide-list="carSlideList4" bg-color="#EBEBEB" />

    <!-- 图文混排组件 5 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList5" mobile-font-color="light" />

    <!-- 幻灯片组件 5 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj7" />
    <CarSlideComponent v-else title="定制套件 浑然一体" :slide-list="carSlideList6" bg-color="#EBEBEB" />
   
    <!-- 幻灯片组件 6 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj6" />
    <CarSlideComponent v-else title="改装潜力 同级领先" :slide-list="carSlideList5" />


    <!-- 车辆性能 -->
    <CarPerformance :is-mobile="isMobile" />

    <!-- 底部生活方式 -->
    <CarLifeBadainJaran :is-mobile="isMobile"/>
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
import Loading from '../components/Loading.vue'
import CarMainBanner from '../components/CarMainBanner.vue'
import CarBannerTwoColumn from '../components/CarBannerTwoColumn.vue'
import CarPurchaseRights from '../components/badainJaran/CarPurchaseRights.vue'
import CarUpTxtDownImg from '../components/CarUpTxtDownImg.vue'
import CarTxtInImgList from '../components/CarTxtInImgList.vue'
import CarBannerCarousel from '../components/CarBannerCarousel.vue'
import CarSlideComponent from '../components/CarSlideComponent.vue'
import CarPerformance from '../components/badainJaran/CarPerformance.vue'
import CarLifeBadainJaran from '../components/badainJaran/CarLifeBadainJaran.vue'
import MobileBannerCarousel from '../components/MobileBannerCarousel.vue'
export default {
  components: {
    Loading,
    CarMainBanner,
    CarBannerTwoColumn,
    CarPurchaseRights,
    CarUpTxtDownImg,
    CarTxtInImgList,
    CarBannerCarousel,
    CarSlideComponent,
    CarPerformance,
    CarLifeBadainJaran,
    MobileBannerCarousel,
  },
  mounted() {
    this.checkDevice(true);
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    destroyFadeAnimate();
    window.removeEventListener('resize', this.checkDevice)
  },
  computed: {
    mainBanner() {
      return this.isMobile ? 'm-BadainJaranMain.jpg' : 'BadainJaranMain.jpg'
    },
    mainTitle() {
      return this.isMobile ? '壮阔世界<br>METTA之境' : '壮阔世界，METTA之境'
    },
    // 图文混排数据 1
    carTxtInImgList() {
      return [
        {
          tag: this.isMobile ? '' : '',
          title: '承袭经典<br>原创表达',
          desc: '新旧并非对立，而是对话<br>让经典越野的灵魂，融入现代科技的锋芒<br>在碰撞中融合，在冲突中共生',
          img: this.imgUrlPrefix + 'sec2_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec2_1.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: this.isMobile ? '' : '',
          title: '精致入微<br>机械之美',
          desc: '浑然一体的精致机械感<br>利落的腰线，饱满的轮眉，轻巧的顶翼<br>与前机盖圆润和谐的棱角<br>每一处都经得起时间的推敲',
          img: this.imgUrlPrefix + 'sec2_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec2_2.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: this.isMobile ? '' : '',
          title: this.isMobile ?'优化比例<br>突显美感':'优化比例 突显美感',
          desc: '延续212越野车经典型格<br>通过提升轮毂大脚，装备后爬梯、顶翼等拓展件<br>用更克制的设计语言，优化车身整体比例',
          img: this.imgUrlPrefix + 'sec2_3.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec2_3.jpg',
          txtLayout: 'left-top',
        },
      ]
    },

    // 图文混排数据 2
    carTxtInImgList2() {
      return [
        {
          tag: '让越野更友好',
          title: '质感座舱 感受先行',
          desc: this.isMobile ? '银灰双拼，勾勒座舱层次<br>现代感与旷野感融合共生' : '银灰双拼，勾勒座舱层次<br>现代感与旷野感融合共生',
          img: this.imgUrlPrefix + 'sec4_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec44_1.jpg',
          txtLayout: 'center-top2',
        }
      ]
    },

    // 图文混排数据 3
    carTxtInImgList3() {
      return [
        {
          tag: this.isMobile ? '' : '',
          title: '新手友好',
          desc: this.isMobile ? '10种驾驶模式+蠕行模式+坦克掉头<br>一键快速切换<br>沙地、泥地、雪地、岩石……<br>智能化自动适配路况，显著降低驾驶难度' : '10种驾驶模式+蠕行模式+坦克掉头<br>一键快速切换<br>沙地、泥地、雪地、岩石……<br>智能化自动适配路况，显著降低驾驶难度',
          img: this.imgUrlPrefix + 'sec6_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec6_1.jpg',
          txtLayout: 'left-top',
        }
      ]
    },

    // 图文混排数据 4
    carTxtInImgList4() {
      return [
        {
          tag: this.isMobile ? '让越野更专业' : '让越野更专业',
          title: this.isMobile ? '实力进阶<br>满配级硬核越野' : '实力进阶 满配级硬核越野',
          desc: this.isMobile ? '' : '',
          img: this.imgUrlPrefix + 'sec8_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec8_1.jpg',
          txtLayout: 'center-top2',
        },
        {
          tag: this.isMobile ? '' : '',
          title: this.isMobile ? '纯血硬汉<br>经典标配' : '纯血硬汉经典标配',
          desc: '前后整体硬桥+大梁+差速锁+分时四驱<br>经典越野配置，给你穿越山河的底气',
          img: this.imgUrlPrefix + 'sec8_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec8_2.jpg',
          txtLayout: this.isMobile ? 'right-top' : 'center-top2',
        },
      ]
    },

    // 图文混排数据 5
    carTxtInImgList5() {
      return [
        {
          tag: '让越野更好玩',
          title: '超越想象<br>个性定制不设限',
          desc: this.isMobile ? '' : '',
          img: this.imgUrlPrefix + 'sec11_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec11_1.jpg',
          txtLayout: 'right-center',
        },
      ]
    },

    


  },
  data() {
    const imgUrlPrefix = '/assets/images/badainJaran/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      // 两列布局数据
      carBannerTwoColumnList: [
        {
          name: 'T01 METTA',
          desc: '天生硬派，均衡进阶',
          img: imgUrlPrefix + 'car-metta.jpg',
          mobileImg: imgUrlPrefix + 'm-car-metta.jpg',
          txtList: [
            '285宽胎',
            '非承载式车身+前后硬桥',
          ],
          link: imgUrlPrefix + '212qrcode.jpg', // 二维码图片
          price: '¥ 18.99万',
        },
        {
          name: 'T01 METTA 巴丹吉林',
          desc: '极致越野，一步到位',
          img: imgUrlPrefix + 'car-metta-bd.jpg',
          mobileImg: imgUrlPrefix + 'm-car-metta-bd.jpg',
          txtList: [
            '33英寸百路驰KO3越野胎',
            '多段可调科曼氮气减震',
            'METTA专属后装越野包',
          ],
          link: imgUrlPrefix + 'qrcode.jpg', // 二维码图片
          price: '¥ 21.99万',
        }
      ],
      // 购车权益数据
      carPurchaseRightsObj : {
        title: '六大购车权益',
        bgImg:  imgUrlPrefix + 'rights-bg.jpg',
        rightsList: [
          {
            name: '焕装礼',
            desc: '置换可享6000元置换补贴',
            icon: imgUrlPrefix + 'icon-rights-1.png',
          },
          {
            name: '尊享礼',
            desc: '京东Plus会员尊享3000元购车补贴',
            icon: imgUrlPrefix + 'icon-rights-2.png',
          },
          {
            name: '金融礼',
            desc: '尊享5000元金融贴息2年13万<br>3年9万0息产品',
            icon: imgUrlPrefix + 'icon-rights-3.png',
          },
          {
            name: '保障礼',
            desc: '基础服务与智控服务终身免费<br>系统OTA升级终身免费<br>娱乐流量5年免费(10GB/月)',
            icon: imgUrlPrefix + 'icon-rights-4.png',
          },
          {
            name: '智联礼',
            desc: '基础服务与智控服务终身免费<br>系统OTA升级终身免费<br>娱乐流量5年免费(10GB/月)',
            icon: imgUrlPrefix + 'icon-rights-5.png',
          },
          {
            name: '巴丹吉林专属焕装礼',
            desc: '免费赠送价值14500元的后装套装<br>包含顶翼、后爬梯、尾灯罩、<br>联动备胎支架<br>以及限量1000套的银色TPU车衣',
            icon: imgUrlPrefix + 'icon-rights-6.png',
          },
        ],
      },
      // 上下布局: 上文字+下图片数据
      carUpTxtDownImgObject: {
        title: '让过往的荣耀自然生长进未来<br>LIVEPASSION, DRIVE LEGEND！',
        desc: '每个时代皆烙印着独属于自己的非凡传奇<br>212，为中国越野而生，承载半个世纪的越野情怀',
        imgList: [imgUrlPrefix + 'sec1_1.jpg']
      },
      
      // 轮播数据
      carBannerCarouselList: [
        {
          img: imgUrlPrefix + 'sec3_3.jpg',
          desc: '全域视野 Omni-View'
        },
        {
          img: imgUrlPrefix + 'sec3_2.jpg',
          desc: '智光领航 Smart Light'
        },
        {
          img: imgUrlPrefix + 'sec3_1.jpg',
          desc: '经典传承 Heritage'
        },
        
      ],
      
      // 幻灯片数据
      carSlideList: [
        {
          img: imgUrlPrefix + 'sec5_1.jpg',
          name: '电动踏板',
          desc: '开门，踏板轻启；关门，悄然收折。每一次上下车，都是一场有仪式感的迎接。<br>承重扎实，收折利落，处处周到。',
        },
        {
          img: imgUrlPrefix + 'sec5_2.jpg',
          name: '云感舒享座椅',
          desc: '座椅、门板、扶手、方向盘——触手可及之处，皆是柔软质感；<br>细腻的缝线与金属饰板交织，于细节中透出克制的精致。',
        },
        {
          img: imgUrlPrefix + 'sec5_3.jpg',
          name: '金属质感机械按键',
          desc: '中控面板区域布置常用功能机械按键，重点功能按键清晰醒目',
        },
        {
          img: imgUrlPrefix + 'sec5_4.jpg',
          name: '座椅智能温控系统',
          desc: '主副驾独立控温，座椅设有通风、加热、按摩功能，<br>方向盘可加热，硬派越野，也可以很体贴',
        }
      ],
      
      // 幻灯片数据 2
      carSlideList2: [
        {
          img: imgUrlPrefix + 'sec7_3.jpg',
          name: '智能互联系统',
          desc: '搭载CarPlay、HiCar、ICCOA三大主流互联协议，支持苹果、华为、小米等主流手机，无感连接，导航、娱乐无缝流转<br>注：Hicar/Carplay 功能正在官方认证中，上线时间以品牌官方最终公告为准。',
        },
        {
          img: imgUrlPrefix + 'sec7_2.jpg',
          name: '540°全景影像系统',
          desc: '超越传统360°影像，增加180°底盘透视功能<br>复杂地形一屏掌控',
        },
        {
          img: imgUrlPrefix + 'sec7_1.jpg',
          name: '智能车机系统',
          desc: '构建车联网+OTA远程升级+智能语音交互三位一体智能座舱体系，<br>实现车辆全时在线，功能持续进化，操控便捷安全',
        },
      ],
      
      // 幻灯片数据 3
      carSlideList3: [
        {
          img: imgUrlPrefix + 'sec9_1.jpg',
          name: '黄金动力组合',
          desc: '采用2.0T发动机+采埃孚8AT变速箱，动力强劲，换挡平顺，久经市场验证',
        },
        {
          img: imgUrlPrefix + 'sec9_2.jpg',
          name: '博格华纳大分动器',
          desc: '4L扭矩放大2.64倍、相比上一代产品扭矩极限提升12%，强化形链轮和加宽链条，润滑油量增加15%，全路况掌控',
        },
        {
          img: imgUrlPrefix + 'sec9_3.jpg',
          name: '4.556主减速比',
          desc: '前后桥主减速比升至4.556，获得更大扭矩输出，提升爬坡、脱困等场景下的动力性能',
        },
        {
          img: imgUrlPrefix + 'sec9_4.jpg',
          name: '高强度前方管桥',
          desc: '垂直载荷能力提升40%，寿命延长20%-30%，展现坚固、省心、从容的全能底盘表现',
        },
      ],
      // 幻灯片数据 4
      carSlideList4: [
        {
          img: imgUrlPrefix + 'sec10_1.jpg',
          name: '33英寸百路驰KO3越野胎',
          desc: '同级更大外尺寸，一步到位的穿越之选。“魔砾”配方+“韧铠”技术，湿地、雪地、碎石路，从容驾驭专业级越野场景',
        },
        {
          img: imgUrlPrefix + 'sec10_2.jpg',
          name: '多段可调科曼氮气减震器',
          desc: '赛车级氮气技术，越野大师调校，升高1.5英寸，更稳的穿越极限，更广的天地视野',
        },
      ],
      
      // 幻灯片数据 5
      carSlideList5: [
        {
          img: imgUrlPrefix + 'sec12_1.jpg',
          name: '多零件预留空位',
          desc: '为车载电台、车外天线、沙漠指示旗杆等零件，预留了孔位，可实现车身钣金免打孔无损安装',
        },
        {
          img: imgUrlPrefix + 'sec12_2.jpg',
          name: '多种可拓展空间',
          desc: '原厂预留仪表台多功能支架拓展孔位，后备厢和后尾门拓展功能等多个可拓展空间，想怎么玩，就怎么玩',
        },
      ],
      // 幻灯片数据 6
      carSlideList6: [
        {
          img: imgUrlPrefix + 'sec13_1.jpg',
          name: '一体式机械后爬梯',
          desc: '延续原车机械设计风格，与整车浑然天成，稳定、耐用，经得起烈日与时间考验',
        },
        {
          img: imgUrlPrefix + 'sec13_2.jpg',
          name: '逐风机械感顶翼',
          desc: '为车身顶部增加整车前突姿态，若逐风而行，更精致，更动感',
        },
        {
          img: imgUrlPrefix + 'sec13_3.jpg',
          name: '巴丹吉林等高线盲窗',
          desc: '灵感来自大自然的轮廓，每一道线条，都是一次出发的召唤',
        },
        {
          img: imgUrlPrefix + 'sec13_4.jpg',
          name: '机械铠甲尾灯罩',
          desc: '立体全包裹式设计，强化车尾层次，精致之中透出机械力量',
        },
      ],

      // 移动端轮播数据
      mobileCarouselObj: {
        title: '品质细节',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec3_3.jpg', name: '机顶盖', desc: '全域视野 Omni-View',
          },
          {
            img: imgUrlPrefix + 'sec3_2.jpg', name: '灯光', desc: '智光领航 Smart Light',
          },
          {
            img: imgUrlPrefix + 'sec3_1.jpg', name: '车身', desc: '经典传承 Heritage',
          },
        ]
      },
      // 移动端轮播数据2
      mobileCarouselObj2: {
        title: '驾乘友好',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec5_1.jpg', name: '电动踏板', desc: '开门，踏板轻启；关门，悄然收折<br>每一次上下车，都是一场有仪式感的迎接<br>承重扎实，收折利落，处处周到',
          },
          {
            img: imgUrlPrefix + 'sec5_2.jpg', name: '云感舒享座椅', desc: '触手可及之处，皆是柔软质感；<br>细腻的缝线与金属饰板交织，于细节中透出克制的精致',
          },
          {
            img: imgUrlPrefix + 'sec5_3.jpg', name: '金属质感机械按键', desc: '中控面板区域布置常用功能机械按键<br>重点功能按键清晰醒目',
          },
          {
            img: imgUrlPrefix + 'sec5_4.jpg', name: '座椅智能温控系统', desc: '主副驾独立控温，座椅设有通风、加热、按摩功能，方向盘可加热，硬派越野，也可以很体贴',
          },
        ]
      },
      // 移动端轮播数据3
      mobileCarouselObj3: {
        title: '智能友好',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec7_1.jpg', name: '智能互联系统', desc: '搭载CarPlay、HiCar、ICCOA三大主流互联<br>注：Hicar/Carplay 功能正在官方认证中<br>上线时间以品牌官方最终公告为准',
          },
          {
            img: imgUrlPrefix + 'sec7_2.jpg', name: '540°全景影像系统', desc: '超越传统360°影像，增加180°底盘透视功能，复杂地形一屏掌控',
          },
          {
            img: imgUrlPrefix + 'sec7_2.jpg', name: '智能车机系统', desc: '构建车联网+OTA远程升级+智能语音交互三位一体智能座舱体系，实现车辆全时在线，功能持续进化，操控便捷安全',
          },
        ]
      },
      // 移动端轮播数据4
      mobileCarouselObj4: {
        title: '黄金动力 核心强韧',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec9_1.jpg', name: '黄金动力组合', desc: '采用2.0T发动机+采埃孚8AT变速箱<br>动力强劲，换挡平顺，久经市场验证',
          },
          {
            img: imgUrlPrefix + 'sec9_2.jpg', name: '博格华纳大分动器', desc: '4L扭矩放大2.64倍、相比上一代产品扭矩极限提升12%<br>强化形链轮和加宽链条，润滑油量增加15%，全路况掌控',
          },
          {
            img: imgUrlPrefix + 'sec9_3.jpg', name: '4.556主减速比', desc: '前后桥主减速比升至4.556，获得更大扭矩输出<br>提升爬坡、脱困等场景下的动力性能',
          },
          {
            img: imgUrlPrefix + 'sec9_4.jpg', name: '高强度前方管桥', desc: '垂直载荷能力提升40%，寿命延长20%-30%<br>展现坚固、省心、从容的全能底盘表现',
          },
        ]
      },
      // 移动端轮播数据5
      mobileCarouselObj5: {
        title: '硬核选择 全域通行',
        bgColor: '#EBEBEB',
        list: [
          {
            img: imgUrlPrefix + 'sec10_1.jpg', name: '33英寸百路驰KO3越野胎', desc: '同级更大外尺寸，一步到位的穿越之选<br>“魔砾”配方+“韧铠”技术，湿地、雪地、碎石路<br>从容驾驭专业级越野场景',
          },
          {
            img: imgUrlPrefix + 'sec10_2.jpg', name: '多段可调科曼氮气减震器', desc: '赛车级氮气技术，越野大师调校，升高1.5英寸，更稳的穿越极限，更广的天地视野',
          },
        ]
      },
      // 移动端轮播数据6
      mobileCarouselObj7: {
        title: '定制套件 浑然一体',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec13_1.jpg', name: '一体式机械后爬梯', desc: '延续原车机械设计风格，与整车浑然天成，稳定、耐用<br>经得起烈日与时间考验',
          },
          {
            img: imgUrlPrefix + 'sec13_2.jpg', name: '逐风机械感顶翼', desc: '为车身顶部增加整车前突姿态，若逐风而行<br>更精致，更动感',
          },
          {
            img: imgUrlPrefix + 'sec13_3.jpg', name: '巴丹吉林等高线盲窗', desc: '灵感来自大自然的轮廓<br>每一道线条，都是一次出发的召唤',
          },
          {
            img: imgUrlPrefix + 'sec13_4.jpg', name: '机械铠甲尾灯罩', desc: '立体全包裹式设计<br>强化车尾层次，精致之中透出机械力量',
          },
        ]
      },
      // 移动端轮播数据7
      mobileCarouselObj6: {
        title: '改装潜力 同级领先',
        bgColor: '#EBEBEB',
        list: [
          {
            img: imgUrlPrefix + 'sec12_1.jpg', name: '多零件预留空位', desc: '为车载电台、车外天线、沙漠指示旗杆等零件，预留了孔位，可实现车身钣金免打孔无损安装',
          },
          {
            img: imgUrlPrefix + 'sec12_2.jpg', name: '多种可拓展空间', desc: '原厂预留仪表台多功能支架拓展孔位，后备厢和后尾门拓展功能等多个可拓展空间，想怎么玩，就怎么玩',
          },
        ]
      },

    }
  },
  methods: {
    checkDevice(forceInit = false) {
      const nextIsMobile = checkIsMobile();
      const changed = this.isMobile !== nextIsMobile;
      this.isMobile = nextIsMobile;

      if (changed || forceInit) {
        this.$nextTick(() => {
          destroyFadeAnimate();
          fadeAnimate();
        });
      }
    },
    pageLoad() {
      this.isLoading = false;
    }
  }
}
</script>

<style lang="less" scoped>
.badain-jaran {
  font-family: 'TsangerYunHei', sans-serif;
  font-weight: @fw2;
}
@media (max-width: @mobile-width) {
  .badain-jaran {
    .sec-4-box {
      .sec-4-item {
        height: auto;
        position: relative;
        .sec-4-txt {
          position: absolute;
          inset: 0;
          text-align: center;
          font-weight: @fw2;
          color: #fff;
          padding-top: 21.33vw;
          h5 {
            font-size: 8.53vw;
            line-height: 1.2;
            font-weight: @fw1;
            margin-top: 1.6vw;
          }
          p {
            font-size: 4.26vw;
          }
        }
      }
    }
  }
}
</style>